import type {
  LiveEventUrlParams,
  MovieUrlParams,
  TvChannelUrlParams,
  TvShowEpisodeUrlParams,
  TvShowUrlParams,
} from '../index.h'

export const generateTvUrlParams = ({
  id,
  channelNumber,
  categoryId,
  categoryName,
  routeName,
  featured,
  favorite,
  purchased,
  recommended,
  recentlyWatched,
  fromSearch,
  collectionId,
}: TvChannelUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('channelId', String(id))

  if (categoryId >= 0) params.set('categoryId', String(categoryId))

  if (categoryName) params.set('categoryName', String(categoryName))

  if (routeName) params.set('routeName', String(routeName))

  if (channelNumber) params.set('channelNumber', String(channelNumber))

  if (featured) params.set('featured', String(featured))

  if (favorite) params.set('favorite', String(favorite))

  if (purchased) params.set('purchased', String(purchased))

  if (recentlyWatched) params.set('recentlyWatched', String(recentlyWatched))

  if (fromSearch) params.set('fromSearch', String(fromSearch))

  if (recommended) params.set('recommended', String(recommended))

  if (collectionId) params.set('collectionId', String(collectionId))

  return params.toString()
}

export const generateMovieUrlParams = ({
  id,
  categoryName,
  routeName,
}: MovieUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('vodId', String(id))

  if (categoryName) params.set('categoryName', String(categoryName))

  if (routeName) params.set('routeName', String(routeName))

  return params.toString()
}

export const generateTvShowUrlParams = ({
  id,
  seasonId,
  episodeId,
  queryCategoryId,
  queryCollectionId,
  queryShowIndex,
  categoryName,
  routeName,
}: TvShowUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('tvshowId', String(id))

  if (seasonId && seasonId >= 0) params.set('seasonId', String(seasonId))

  if (episodeId && episodeId >= 0) params.set('episodeId', String(episodeId))

  if (categoryName) params.set('categoryName', String(categoryName))

  if (routeName) params.set('routeName', String(routeName))

  return `${params.toString()}${queryCategoryId ?? ''}${queryCollectionId ?? ''}${queryShowIndex ?? ''}`
}

export const generateTvShowEpisodeUrlParams = ({
  id,
  seasonId,
  tvShowId,
  queryCategoryId,
  queryCollectionId,
  queryShowIndex,
  categoryName,
  routeName,
}: TvShowEpisodeUrlParams): string => {
  const params = new URLSearchParams()

  if (tvShowId && tvShowId >= 0) params.set('tvshowId', String(tvShowId))

  if (seasonId && seasonId >= 0) params.set('seasonId', String(seasonId))

  if (id >= 0) params.set('episodeId', String(id))

  if (categoryName) params.set('categoryName', String(categoryName))

  if (routeName) params.set('routeName', String(routeName))

  return `${params.toString()}${queryCategoryId ?? ''}${queryCollectionId ?? ''}${queryShowIndex ?? ''}`
}

export const generateLiveEventUrl = ({
  id,
  categoryName,
  routeName,
}: LiveEventUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('liveEventId', String(id))

  if (categoryName) params.set('categoryName', String(categoryName))

  if (routeName) params.set('routeName', String(routeName))

  return params.toString()
}
